import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon, MailIcon, ClipboardListIcon, SparklesIcon, LightbulbIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 24
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-60px'
  },
  transition: {
    duration: 0.5,
    ease: 'easeOut'
  }
};
export function HowItWorksSection() {
  return <section className="w-full px-5 py-16 md:py-24" data-id="element-179">
      <div className="max-w-3xl mx-auto" data-id="element-180">
        <motion.h2 {...fadeInUp} className="text-2xl md:text-4xl font-semibold text-[#2C2825] mb-14 text-center" data-id="element-181">
          Así de fácil es empezar
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-4" data-id="element-182">
          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.05
        }} className="text-center" data-id="element-183">
            <div className="w-14 h-14 rounded-full bg-[#C4956A]/10 flex items-center justify-center mx-auto mb-4" data-id="element-184">
              <ShoppingCartIcon className="w-6 h-6 text-[#C4956A]" data-id="element-185" />
            </div>
            <span className="block text-xs font-semibold uppercase tracking-wider text-[#C4956A] mb-2" data-id="element-186">
              1
            </span>
            <p className="text-[#2C2825]/75 text-sm leading-relaxed" data-id="element-187">
              Haz clic en el botón y completa tu compra (menos de 1 minuto)
            </p>
          </motion.div>

          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.1
        }} className="text-center" data-id="element-188">
            <div className="w-14 h-14 rounded-full bg-[#C4956A]/10 flex items-center justify-center mx-auto mb-4" data-id="element-189">
              <MailIcon className="w-6 h-6 text-[#C4956A]" data-id="element-190" />
            </div>
            <span className="block text-xs font-semibold uppercase tracking-wider text-[#C4956A] mb-2" data-id="element-191">
              2
            </span>
            <p className="text-[#2C2825]/75 text-sm leading-relaxed" data-id="element-192">
              Recibes un email con el enlace de descarga al instante
            </p>
          </motion.div>

          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.15
        }} className="text-center" data-id="element-193">
            <div className="w-14 h-14 rounded-full bg-[#C4956A]/10 flex items-center justify-center mx-auto mb-4" data-id="element-194">
              <ClipboardListIcon className="w-6 h-6 text-[#C4956A]" data-id="element-195" />
            </div>
            <span className="block text-xs font-semibold uppercase tracking-wider text-[#C4956A] mb-2" data-id="element-196">
              3
            </span>
            <p className="text-[#2C2825]/75 text-sm leading-relaxed" data-id="element-197">
              Haz el test visual, identifica tu tipo y sigue tu rutina
              personalizada
            </p>
          </motion.div>

          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.2
        }} className="text-center" data-id="element-198">
            <div className="w-14 h-14 rounded-full bg-[#C4956A]/10 flex items-center justify-center mx-auto mb-4" data-id="element-199">
              <SparklesIcon className="w-6 h-6 text-[#C4956A]" data-id="element-200" />
            </div>
            <span className="block text-xs font-semibold uppercase tracking-wider text-[#C4956A] mb-2" data-id="element-201">
              4
            </span>
            <p className="text-[#2C2825]/75 text-sm leading-relaxed" data-id="element-202">
              En 7 días, mira al espejo y nota la diferencia
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}